module.exports = __webpack_public_path__ + "media/images/loading-3c7d57af0a9491e35e89d4044e8c9aa6.svg";